import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../stores';
import './style.scss';
import { View } from '../../components';
import Clients from './Clients';
import Users from './Users';
import Profile from './Profile';
import Briefs from './Briefs';
import Overview from './Overview';
import Audit from './Audit';
import Projects from './Projects';
import Professionals from './Professionals';

const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`
var mobile = require('is-mobile');

const AdminDashboard = observer(() => {
    
    const { authStore, uiStore } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [PageSelected, setPageSelected] = useState('Overview');
    const [FullName, setFullName] = useState('');
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);

    useEffect(() => {
        try {
            let fullNames = authStore.user.firstName + ' ' + authStore.user.lastName;
            setFullName(fullNames);
        } catch (error) {
            uiStore.showNotification('Failed to load user information.', 'error');
        }
    }, [authStore.user, uiStore]); // Added uiStore as dependency

    const isLongName = FullName.length > 17;
    
    const handleTabClick = (e) => {
        try {
            setPageSelected(e.target.id);
            forceUpdate();
        } catch (error) {
            uiStore.showNotification('Failed to switch tab.', 'error');
        }
    };

    const logOutClicked = () => {
        try {
            setShowLogoutPopup(true);
        } catch (error) {
            uiStore.showNotification('Failed to initiate logout.', 'error');
        }
    };

    const confirmLogout = async () => {
        try {
            await authStore.logout(); // Make sure logout is awaited if it's async
            setShowLogoutPopup(false);
        } catch (error) {
            uiStore.showNotification('Failed to log out. Please try again.', 'error');
            setShowLogoutPopup(false);
        }
    };

    const cancelLogout = () => {
        try {
            setShowLogoutPopup(false);
        } catch (error) {
            uiStore.showNotification('An error occurred.', 'error');
        }
    };

    if (mobile()) {
        return (
            <div>
                {/* Mobile content */}
            </div>
        );
    } else {
        return (
            <View className='CredippleDashboard'>
                <div className='dashSidebar'>
                    <div className='userProfileInfo'>
                        <div className='userProfilePictureConatiner' style={{ cursor: 'pointer' }} id='Profile' onClick={handleTabClick}>
                            <img className='profilePicture' src={UserIcon} alt='Profile Picture' />
                        </div>
                        <div className='userDetails'>
                            {isLongName ? (
                                <>
                                    <p className='userNames'>{authStore.user.firstName}</p>
                                    <p className='userNames'>{authStore.user.lastName}</p>
                                </>
                            ) : (
                                <>
                                    <p id='Profile' onClick={handleTabClick} style={{ cursor: 'pointer' }} className='userNames'>{FullName}</p>
                                    <p id='Profile' onClick={handleTabClick} style={{ cursor: 'pointer' }} className='userEmail'>{authStore.user.email}</p>
                                </>
                            )}
                        </div>
                    </div>
                    <hr className='hr' />
                    <div className='dashboardTabs'>
                        <p className={PageSelected === "Overview" ? 'selectedTabLabel' : 'tabLabel'} id='Overview' onClick={handleTabClick}>Overview</p>
                        <p className={PageSelected === "Audit" ? 'selectedTabLabel' : 'tabLabel'} id='Audit' onClick={handleTabClick}>Audit</p>
                        {Object.keys(authStore.user).includes('permissions') && Array.isArray(authStore.user?.permissions) &&
                            <>
                                {authStore.user.permissions.some(permission => permission.includes("Client")) ? <p className={PageSelected === "Clients" ? 'selectedTabLabel' : 'tabLabel'} id='Clients' onClick={handleTabClick}>Clients</p> : null}
                                {/* {authStore.user.permissions.some(permission => permission.includes("User")) ? <p className={PageSelected === "Professionals" ? 'selectedTabLabel' : 'tabLabel'} id='Professionals' onClick={handleTabClick}>Professionals</p> : null} */}
                                {/* {authStore.user.permissions.some(permission => permission.includes("Brief")) ? <p className={PageSelected === "Projects" ? 'selectedTabLabel' : 'tabLabel'} id='Projects' onClick={handleTabClick}>Projects</p> : null} */}
                                {/* {authStore.user.permissions.some(permission => permission.includes("Brief")) ? (<p className={PageSelected === "Briefs" ? 'selectedTabLabel' : 'tabLabel'} id='Briefs' onClick={handleTabClick}>Briefs</p>) : null} */}
                                {authStore.user.permissions.some(permission => permission.includes("User")) ? (<p className={PageSelected === "Users" ? 'selectedTabLabel' : 'tabLabel'} id='Users' onClick={handleTabClick}>Users</p>) : null}
                            </>
                        }
                        <p className='tabLabel' id='Logout' onClick={logOutClicked}>Logout</p>
                    </div>
                </div>
                <div className='dashBody' >
                    <div className='selectedTabBody' style={{ width: PageSelected === 'Briefs' || PageSelected === 'Projects' ? '100%' : '', margin: PageSelected === 'Briefs' || PageSelected === 'Projects' ? '0px' : '' }}>
                        {(PageSelected === 'Overview') ? <Overview /> : null}
                        {(PageSelected === 'Audit') ? <Audit /> : null}
                        {(PageSelected === 'Users') ? <Users /> : null}
                        {(PageSelected === 'Profile') ? <Profile /> : null}
                        {(PageSelected === 'Briefs') ? <Briefs /> : null}
                        {(PageSelected === 'Clients') ? <Clients /> : null}
                        {(PageSelected === 'Professionals') ? <Professionals /> : null}
                        {(PageSelected === 'Projects') ? <Projects /> : null}
                    </div>
                    <div className='credippleDashFooter'>
                        <p className='footerContent' onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>T's & C's</p>
                        <p className='footerContent' onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>Privacy</p>
                        <p className='footerContent' onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>FAQ'S</p>
                        <p className='footerContent' onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'} onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}>CC.Credipple.2024</p>
                    </div>
                </div>

                {/* Logout Confirmation Popup */}
                {showLogoutPopup && (
                    <View className='logoutPopup'>
                        <div className='popupContent'>
                            <p>Are you sure you want to log out?</p>
                            <button onClick={confirmLogout}>Yes</button>
                            <button onClick={cancelLogout}>No</button>
                        </div>
                    </View>
                )}
            </View>
        )
    }
})

export default AdminDashboard;